import { Printer, Lock } from "lucide-react";
import { PRODUCT_MAP, fmt } from "@/lib/load/products";
import { ProductLabel } from "@/components/load/ApiSymbol";

const status = (c, load, warn, t) => {
  if (c.locked_dry) return <span className="load-over"><Lock size={12} /> {t("LOCKED DRY — DO NOT LOAD")}</span>;
  if (!load?.product) return <span className="card-sub">{t("Empty — not needed")}</span>;
  const base = load.gallons === c.capacity ? t("FILL TO SHELL (100%)") : t("PRESET {g} — {e} gal left empty", { g: fmt(load.gallons), e: fmt(c.capacity - load.gallons) });
  return <>{base}{warn && <span className="load-warn-tag">{t("CHECK NEIGHBOR")}</span>}</>;
};

export const RackCard = ({ trailer, customer, loads, warnings, t }) => {
  const warnIdx = new Set(warnings.flatMap((w) => [w.left, w.right]));
  const total = (loads || []).reduce((a, l) => a + l.gallons, 0);
  return (
    <div className="card load-card load-rack" data-testid="rack-card">
      <div className="load-rack-head">
        <div className="section-title"><span className="load-step">3</span>{t("Rack loading card")}</div>
        <button type="button" className="ghost-btn" onClick={() => window.print()} data-testid="print-card-btn"><Printer size={16} />{t("Print")}</button>
      </div>
      {customer && <div className="card-sub" data-testid="rack-customer">{t("Customer")}: <b>{customer.name}</b></div>}
      <div className="load-print-only">{trailer.name} · {new Date().toLocaleString()}</div>
      <div className="load-table-wrap">
        <table className="load-table">
          <thead><tr><th>{t("Pocket")}</th><th>{t("Cap")}</th><th>{t("Product")}</th><th>UN</th><th>{t("Load")}</th>{customer && <th>{t("Tank")}</th>}<th>{t("Instructions")}</th></tr></thead>
          <tbody>
            {trailer.compartments.map((c, i) => {
              const l = loads?.[i];
              const p = l?.product && PRODUCT_MAP[l.product];
              return (
                <tr key={i} data-testid={`rack-row-${i}`}>
                  <td><b>{c.name}</b>{c.double_bulkhead && <span className="load-db">DB</span>}</td>
                  <td>{`${fmt(c.capacity)} gal`}</td>
                  <td>{p ? <ProductLabel p={p} /> : "—"}</td>
                  <td>{p ? p.un : "—"}</td>
                  <td data-testid={`rack-gal-${i}`}><b>{`${fmt(l?.gallons)} gal`}</b></td>
                  {customer && <td data-testid={`rack-tank-${i}`}>{l?.label || "—"}</td>}
                  <td>{status(c, l, warnIdx.has(i), t)}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot><tr><td colSpan={4}>{t("TOTAL LOADED")}</td><td data-testid="rack-total"><b>{`${fmt(total)} gal`}</b></td>{customer && <td />}<td /></tr></tfoot>
        </table>
      </div>
    </div>
  );
};
